import styled from '@emotion/styled';
import { Icon, Select, Typography } from 'src/components-dummy';
import { LinkButton } from 'src/components-dummy/LinkButton/LinkButton';

export const DeleteButtonStyled = styled(LinkButton)`
  margin-left: auto;
  color: ${({ theme }) => theme.palette.custom['red-80']};

  svg {
    & > path {
      stroke: ${({ theme }) => theme.palette.custom['red-80']};
    }
  }
`;

export const CardTitleStyled = styled(Typography)`
  margin-left: 3px;
`;

export const FieldSelectStyled = styled(Select)`
  .MuiInputBase-input {
    background-color: ${({ theme }) => theme.palette.common.white};
    border: solid 1px ${({ theme }) => theme.palette.custom['gray-50']};
    color: ${({ theme }) => theme.palette.custom['gray-30']};
    font-size: 14px;
  }
`;

export const SelectLabelStyled = styled(Typography)`
  margin-left: 3px;
  margin-bottom: -6px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 5px;
  gap: 4px;
`;

export const CardTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 4px;
`;

export const MoveButtonStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const IconStyled = styled(Icon)<{ rotateDegrees: number }>`
  margin-left: auto;
  margin-bottom: 2px;
  transform: rotate(${({ rotateDegrees }) => rotateDegrees}deg);
  transition: transform 0.3s;
  width: 10px;
  height: 10px;
`;
